module.exports = __webpack_public_path__ + "img/exhibits3.f975f00e.png";